<template>
  <div class="row">
    <div class="col-md">
      <dl class="dl-horizontal">
        <dt>id</dt>
        <dd>
          <router-link
            class="text-monospace text-muted"
            :to="`/receipts/${receipt.id}`"
          >{{receipt.id}}</router-link>
        </dd>

        <dt>modem_command_id</dt>
        <dd>
          <router-link
            class="text-monospace text-muted"
            :to="`/commands/${receipt.modem_command_id}`"
          >{{receipt.modem_command_id}}</router-link>
        </dd>
        <vue-json-pretty :data="receipt.request"/>
      </dl>
    </div>
    <div class="col-md">
      <div class="text-monospace" v-if="receipt.response">{{receipt.response}}</div>
      <dl class="dl-horizontal mt-3">
        <dt>source</dt>
        <dd>{{ receipt.source || '—' }}</dd>

        <dt>comment</dt>
        <dd>{{ receipt.comment || '—' }}</dd>
      </dl>
      <button
        v-if="canResend"
        class="btn btn-outline-primary btn-sm mt-3"
        :disabled="sending"
        @click="resend"
      >{{ sending ? 'Отправка…' : 'Отправить снова' }}</button>
    </div>
  </div>
</template>

<script>
  import VueJsonPretty from 'vue-json-pretty'
  import api from '../api'

  export default {
    components: {VueJsonPretty},
    props: {
      receipt: {
        type: Object,
      },
    },
    data () {
      return {sending: false}
    },
    computed: {
      canResend () {
        return !/^2\d\d$/.test(String(this.receipt.status || ''))
      },
    },
    methods: {
      resend () {
        this.sending = true
        api.post(`receipts/${this.receipt.id}/resend`)
          .then(() => this.$root.showAlert('Чек поставлен в очередь на повторную отправку'))
          .catch(() => this.$root.showAlert('Не удалось поставить чек в очередь'))
          .finally(() => { this.sending = false })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/receipt-details.vue